export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Colunas Sobre",
              attributes: { class: 'row-cubo' },
              components: [
                {
                  type: 'columnImageAbout2'
                },
                {
                  type: 'columnAbout2'
                }  
              ],
              styles: `
             .row-cubo{
                display: flex; 
                flex-direction:row; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
             }
            `,
             },
          },
          view: {
      
          },
    };
  
    return component;
  };
  